webpackJsonp([30787653422453],{

/***/ 1567:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/3d/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-3-d-b89af9142215c1eebf43.js